import { useQuery } from "@tanstack/react-query";
import { fetchStaffScheduleByDate } from "@/lib/services/staffService";
import type { DateTime } from "luxon";

/**
 * React Query hook for fetching the full staff schedule mapping: { [date: string]: number[] }
 * @param displayedMonth - The month currently displayed in the calendar.
 *        When the user navigates months the query key changes, triggering a
 *        refetch so the 3-month schedule window is centred on the visible month.
 */
export function useStaffScheduleByDate(displayedMonth?: DateTime) {
  // Stable key fragment: "YYYY-MM" of the month being viewed
  const monthKey = displayedMonth?.toFormat("yyyy-MM") ?? "now";

  return useQuery({
    queryKey: ["staffScheduleByDate", monthKey],
    queryFn: () => fetchStaffScheduleByDate(displayedMonth),
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
}
